import { GET_NOTIFICATION, GET_NOTIFICATION_SUCCESS, GET_NOTIFICATION_FAILER } from './notificationType';
import { IAction } from './INoticiationAction';

export const getNotificationRequest = (): IAction => {
    return {
        type: GET_NOTIFICATION,
    };
}

export const getNotificationSucces = (notification: any): IAction => {
    return {
        type: GET_NOTIFICATION_SUCCESS,
        payload: notification
    };
}

export const getNotificationFailer = (error: any): IAction => {
    return {
        type: GET_NOTIFICATION_FAILER,
        payload: error
    }
}
